import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import Balloon from '../game/Balloon';
import MrBee from '../game/MrBee';
import SoundAssetKeys from '../SoundAssetKeys';
import UIAssetKeys from '../UIAssetKeys';
import { dotPop } from '../Utilities';
import Game from './Game';
import LocalizationSoundAssetKeys from '../Localization-SoundAssetKeys';

export default class TitleScreen extends Phaser.Scene {
  static get KEY() { return 'TitleScreen'; }

  constructor() {
    super({ key: TitleScreen.KEY });
  }

  init() {
    this.title = null;
    this.subtitle = null;
    this.lblPop = null;
    this.btnGo = null;

    this.mrbee = null;
    this.balloon = null;
    this.popPoint = null;
  }

  create() {
    this.bg = ABCyaPhaser.Images.addImage(0,0, UIAssetKeys._MainBackground, this).setOrigin(0);

    this.title = ABCyaPhaser.Images.addImage(0,0,UIAssetKeys._Label_Balloon, this).setOrigin(0);
    this.title.x = this.scale.width / 2 - this.title.width / 2;
    this.title.y = -this.title.height;

    this.subtitle = ABCyaPhaser.Images.addImage(0,0,UIAssetKeys._Label_Subtitle, this).setOrigin(0);
    this.subtitle.x = this.scale.width / 2 - this.subtitle.width / 2;
    this.subtitle.y = -this.subtitle.height;

    this.lblPop = ABCyaPhaser.Images.addImage(0,0,UIAssetKeys._Pop_Full, this);
    this.lblPop.x = this.scale.width / 2;
    this.lblPop.y = this.scale.height / 2;
    this.lblPop.scale = 0;

    this.btnGo = ABCyaPhaser.Images.addImage(this.scale.width / 2,0,UIAssetKeys._BtnGo, this).setInteractive();
    this.btnGo.alpha = 0;
    this.btnGo.once(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.onClickGo, this);

    this.mrbee = new MrBee(this);

    this.mrbee.sizeScale = 1.0;
    const mrBeeBounds = this.mrbee.getBounds();
    this.mrbee.list.forEach((child) => {
      child.setPosition(child.x - mrBeeBounds.width / 2, child.y - mrBeeBounds.height / 2);
    });
    let x = -500;
    let y = -500;
    this.mrbee.setPosAndAttractor(x,y,0,0);
    this.mrbee.x = this.mrbee.pos.x;
    this.mrbee.y = this.mrbee.pos.y;
    this.mrbee.on('ARRIVED', this.beeAtPoint, this);

    x = this.scale.width / 2;
    y = 320;
    this.popPoint = new Phaser.Math.Vector2(x,y);

    this.balloon = new Balloon(this, null, this.scale.width / 2 - 20, this.scale.height + 100);
    this.balloon.reset(this.scale.width / 2 - 20, this.scale.height + 100, Phaser.Math.Between(1,5));
    this.balloon.balloonTop.on('BALLOON_FINISHED', this.balloonInSpot, this);
    this.add.existing(this.mrbee);
    this.music = ABCyaPhaser.Audio.createSound(this);
    ABCyaPhaser.Audio.playSound(SoundAssetKeys._cloud_walking_60, this.music, 1, true);

    this.startIntro();
  }

  onClickGo () {
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._click, this);
    ABCyaPhaser.Tweens.addTween(this.title, 440, { alpha: 0 }, Phaser.Math.Easing.Linear);
    ABCyaPhaser.Tweens.addTween(this.subtitle, 440, { alpha: 0 }, Phaser.Math.Easing.Linear);
    ABCyaPhaser.Tweens.addTween(this.lblPop, 440, { alpha: 0 }, Phaser.Math.Easing.Linear);
    ABCyaPhaser.Tweens.addTween(this.btnGo, 440, { scale: 0 }, Phaser.Math.Easing.Linear);

    this.mrbee.off('ARRIVED');
    this.mrbee.initMoveTo(this.scale.width + 600, this.mrbee.pos.y + Phaser.Math.Between(1,60), 60);
    this.time.delayedCall(700, this.nextScene, null, this);
  }

  nextScene () {
    this.sound.stopAll();
    this.music.destroy();
    this.music = null;
    this.scene.start(Game.KEY);
  }

  beeAtPoint() {
    this.mrbee.doSting();
    this.balloon.pop();

    this.showPop();
    this.time.delayedCall(200, this.freeBee, null, this);
  }

  showPop () {
    this.lblPop.y = this.popPoint.y;
    this.lblPop.scale = 0;
    ABCyaPhaser.Tweens.addTween(this.lblPop, 500, { scale: 1 }, Phaser.Math.Easing.Bounce.Out);
  }

  freeBee () {
    this.children.bringToTop(this.mrbee);

    this.mrbee.off('ARRIVED');
    this.mrbee.on('ARRIVED', this.settleBee, this);
    this.mrbee.initMoveTo(-100, this.scale.height - 160);
  }

  settleBee () {
    this.showGo();
    this.mrbee.turn(-1);
    this.mrbee.initForceMove(100, this.scale.height - 200);
  }

  showGo () {
    const goOffset = 65;
    this.btnGo.scale = 0;
    this.btnGo.y = this.scale.height - this.btnGo.height - goOffset;
    dotPop(this.btnGo);
  }

  balloonInSpot () {
    this.showSubtitle();
    this.bringBee();
    this.balloon.initHoverFloat(this.balloon.pos.x,this.balloon.pos.y + 50 - Phaser.Math.Between(13,16));
  }

  showSubtitle () {
    const y = 400;
    ABCyaPhaser.Tweens.addTween(this.subtitle, 400, { y }, Phaser.Math.Easing.Quadratic.Out);
    this.children.bringToTop(this.subtitle);
  }

  bringBee () {
    let destX = this.popPoint.x;
    let destY = this.popPoint.y;
    const dir = this.mrbee.pos.x - destX;
    if (dir < 0) {
      destX += 70;
      destY -= 100;
    }
    else {
      destX -= 35;
    }
    this.mrbee.initMoveTo(destX, destY);
  }

  startIntro () {
    const y = 100;
    ABCyaPhaser.Tweens.addTween(this.title, 420, { y }, Phaser.Math.Easing.Quadratic.Out);
    this.bringBalloon();
    ABCyaPhaser.Audio.playOneShot(LocalizationSoundAssetKeys._intro, this, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);
  }

  bringBalloon () {
    this.balloon.initMoveTo(this.popPoint.x, this.popPoint.y - 75);
  }

  update (time, delta) {
    const deltaSeconds = delta / 1000;
    this.mrbee.tick(deltaSeconds);
    this.balloon.tick(deltaSeconds);
  }
}